import {
  ConversationData,
  ConversationStatusGroup,
  dispatch,
  getConversationStatusMap,
  updateCurrentConversation,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { useState, useCallback } from 'react';
import { ConversationModalState, ConvervationModalVariant } from '../../types';
import { TAGS_MAP, TagsKey } from '../contstants';

const modalInitialState: ConversationModalState = {
  conversation: {
    metadata: {
      tags: [],
    },
    lastMessageAt: '',
    status: '',
    isAssigned: false,
    createdAt: '',
    title: '',
    description: '',
    conversationThreadId: '',
    workspaceId: '',
    customerId: '',
    assignedTo: [],
  },
  open: false,
  variant: 'none',
};

export const useGetCommonConverationFunctions = () => {
  const statusMap = useAppSelector(getConversationStatusMap);
  const [modalState, setModalState] =
    useState<ConversationModalState>(modalInitialState);

  const findStatusCategory = useCallback(
    (status: string): ConversationStatusGroup => {
      return (Object.entries(statusMap).find(([_, values]) =>
        values.includes(status)
      )?.[0] ?? ConversationStatusGroup.OPEN) as ConversationStatusGroup;
    },
    [statusMap]
  );

  const onActionPress = ({
    action,
    conversation,
  }: {
    action: ConvervationModalVariant;
    conversation: ConversationData;
  }) => {
    setModalState({
      variant: action,
      open: true,
      conversation,
    });
  };

  const onCloseModal = () => {
    setModalState(modalInitialState);
  };

  const updateSelectedConversation = (conversation: ConversationData) => {
    dispatch(updateCurrentConversation(conversation));
  };

  const findTagType = (tag: string): TagsKey => {
    return (
      (Object.entries(TAGS_MAP).find(([_, values]) =>
        values.includes(tag)
      )?.[0] as TagsKey) ?? 'custom'
    );
  };

  return {
    findStatusCategory,
    onActionPress,
    modalState,
    onCloseModal,
    updateSelectedConversation,
    findTagType,
  };
};
